import { AddRounded, Delete, RemoveRounded } from '@mui/icons-material';
import {
  Box,
  IconButton,
  styled,
  Typography,
  SxProps,
  Theme,
} from '@mui/material';

interface Props {
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  hasCustomizations?: boolean;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const QuantitySelector = ({
  quantity,
  onQuantityChange,
  hasCustomizations,
  disabled,
  sx,
}: Props) => {
  const handleIncrement = () => {
    onQuantityChange(1);
  };

  const handleDecrement = () => {
    if (quantity > 0) {
      onQuantityChange(-1);
    }
  };

  const QuantitySelectorContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '20px',
    backgroundColor: theme.palette.common.white,
    padding: '4px 0px',
    transition: 'background-color 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
    width: 'fit-content',
    height: '40px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
  }));

  if (quantity === 0) {
    return (
      <IconButton
        onClick={handleIncrement}
        sx={{
          bgcolor: 'common.white',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
          '&:hover': {
            bgcolor: 'common.white',
          },
        }}
        disabled={disabled}
      >
        <AddRounded />
      </IconButton>
    );
  }

  if (hasCustomizations) {
    return (
      <IconButton
        onClick={handleIncrement}
        sx={{
          bgcolor: 'common.white',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
          width: 'fit-content',
          minWidth: '40px',
          height: '40px',
          '&:hover': {
            bgcolor: 'common.white',
          },
        }}
        disabled={disabled}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: '500',
            fontSize: '16px',
            color: 'text.primary',
            lineHeight: 1,
          }}
        >
          {quantity}
        </Typography>
      </IconButton>
    );
  }
  return (
    <QuantitySelectorContainer sx={sx}>
      <IconButton
        onClick={handleDecrement}
        disabled={quantity === 0 || disabled}
      >
        {quantity === 1 ? <Delete /> : <RemoveRounded />}
      </IconButton>
      <Typography
        variant="body1"
        sx={{
          fontWeight: '500',
          fontSize: '16px',
          color: 'text.primary',
          lineHeight: 1,
        }}
      >
        {quantity}
      </Typography>
      <IconButton onClick={handleIncrement} disabled={disabled}>
        <AddRounded />
      </IconButton>
    </QuantitySelectorContainer>
  );
};

export default QuantitySelector;
